<template>
  <div v-if="agent">
    <!-- fields -->
    <!-- if locked -->
    <div v-if="agent.isLocked" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label agent-is-locked">Locked until</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">{{agent.lockoutEndDate | datetime}}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- username -->
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Login</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text" :O_O="agent.uPwd">{{agent.username}}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- email -->
    <div v-if="agent.email" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Email</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{agent.email}}
            </span>
          </p>
        </div>
      </div>
    </div>
    <!-- phone number -->
    <div v-if="agent.phoneNumber" class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Phone number</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <span class="oc-form-text">
              {{agent.phoneNumber}}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import state from '../../../../../state'
  import utils from '../../../../../utils'
  import agentService from '../../../../../services/agent.service'

  import description from '../../../../common/description.vue'

  export default {
    name: 'agent-general',
    components: { description },
    data() {
      return {
        agent: null
      }
    },
    computed: {
      agentId() {
        return this.$route.params.agentId;
      }
    },
    async mounted() {
      await this.load();
    },
    methods: {
      async load() {
        await agentService.load(this.agentId);
        let agent = utils.clone(state.editAgent.get());
        this.agent = agent;
      },
      async save() {
        await agentService.save(this.agent);
        await this.load();
      }
    }
  }
</script>
<style scoped>
  .agent-is-locked {
    color: red !important;
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/agents/agent/general.vue